import { create } from "zustand";
import { FormsApplicationsState } from "../_types/formsApplications.types";

export const useFormsApplicationsStore = create<FormsApplicationsState>((set) => ({
  type: "all",
  period: "all",
  status: "all",
  search: "",
  page: 1,
  limit: 10,
  setType: (type) => set({ type, page: 1 }),
  setPeriod: (period) => set({ period, page: 1 }),
  setStatus: (status) => set({ status, page: 1 }),
  setSearch: (search) => set({ search, page: 1 }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),
}));
